import React from "react";
import { processing, clickHere, loginTexts } from "../../locales/en";
import PropTypes from "prop-types";

const TwoFaField = ({
  errors,
  success,
  loading,
  onChange,
  onResend,
  label,
  emailText
}) => (
  <div className="input-row">
    <div className="input-group">
      <div className="otp-passowrd">
        <input
          type="number"
          placeholder={loginTexts.twoFactorAuthenticationCode}
          onChange={(e) => onChange(e.target.value)}
        />

        {errors.invalidMessage && (
          <p className="error-message">
            <small>{errors.invalidMessage}</small>
          </p>
        )}

        {errors.twoFactorCode && (
          <p className="error-message">
            <small>{errors.twoFactorCode}</small>
          </p>
        )}

        {success.twoFactorResent && (
          <p className="error-message text-success">
            <small>{success.twoFactorResent}</small>
          </p>
        )}
      </div>

      <div className="resend-otp mt-1">
        <p>
          {label}
          <button
            type="button"
            className="btn btn-primary btn-small"
            disabled={loading}
            onClick={onResend}
          >
            {loading ? processing : clickHere}
          </button>
          {` ${emailText}`}
        </p>
      </div>
    </div>
  </div>
);

export default TwoFaField;

TwoFaField.propTypes = {
  errors: PropTypes.object,
  success: PropTypes.object,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onResend: PropTypes.func,
  label: PropTypes.string,
  emailText: PropTypes.string
};
